import React from 'react';
import PropTypes from 'prop-types';
import capitalize from '../../../stringUtils';
import './ProjectEmploymentType.scss';
function ProjectEmploymentType(_ref) {
  var _ref$employmentType = _ref.employmentType,
    employmentType = _ref$employmentType === void 0 ? '' : _ref$employmentType,
    _ref$showProjectEmplo = _ref.showProjectEmploymentType,
    showProjectEmploymentType = _ref$showProjectEmplo === void 0 ? false : _ref$showProjectEmplo;
  return showProjectEmploymentType && /*#__PURE__*/React.createElement("div", {
    className: "".concat(employmentType, "-badge")
  }, capitalize(employmentType), ' ', "Position");
}
ProjectEmploymentType.propTypes = {
  employmentType: PropTypes.string,
  showProjectEmploymentType: PropTypes.bool
};
export default ProjectEmploymentType;